import { IconType } from "@/types/utils";
import React from "react";

const UserNavIcon: IconType = ({ size, ...otherProps }) => (
  <svg
    width={size || "24"}
    height={size || "24"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...otherProps}
  >
    <path d="M20,21V19a4,4,0,0,0-4-4H8a4,4,0,0,0-4,4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

export default UserNavIcon;
